export default "__VITE_ASSET__BHGU55IT__"